import { render, staticRenderFns } from "./BuildMetrics.vue?vue&type=template&id=1a50271b&scoped=true&"
import script from "./BuildMetrics.vue?vue&type=script&setup=true&lang=js&"
export * from "./BuildMetrics.vue?vue&type=script&setup=true&lang=js&"
import style0 from "./BuildMetrics.vue?vue&type=style&index=0&id=1a50271b&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1a50271b",
  null
  
)

export default component.exports